import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Alert, Card } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
} from "../../../components/Component";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Modal, ModalBody, Col, Spinner } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import { FormProvider, useForm } from "react-hook-form";
import FormCheckbox from "../../form-components/CheckboxComponent";
import rolesApi from "../../../api/master/roles";
import FormTextArea from "../../form-components/TextAreaComponent";
import departments from "../../../api/master/departments";
import FormatDate from "../DateFormater";
import { useSelector } from "react-redux";
import { ReactTyped } from "react-typed";

interface SelectOptions {
  label: string;
  value: string;
}
const RoleViewDetails: FC = () => {
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);
  const [modalEditBlockName, setModalEditBlockName]: any = useState("");
  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  let { roleID } = useParams();
  const [data, setData] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalGI, setGIModal] = useState(false);
  const [modalTab, setModalTab] = useState("1");
  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
    referenceID: "",
    deptID: "",
    status: "",
    accessibility: [],
  });
  const methods = useForm({
    mode: "onChange",
  });

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
    getValues,
    setValue,
    trigger,
    reset,
  } = methods;
  const [accessibilityKeys, setaccessibilityKeys] = useState([]);
  const [departmentData, setDepartmentData] = useState<SelectOptions[]>([]);

  const updatedAccessibilityOptions = [
    {
      label: "Sub Feature",
      value: "Sub Feature",
    },
    {
      label: "Create / Add",
      value: "ADD",
    },
    {
      label: "View",
      value: "VIEW",
    },
    {
      label: "Edit / Update",
      value: "EDIT",
    },
    {
      label: " Delete / Inactive",
      value: "CANCEL",
    },
    {
      label: "Approve / Reject",
      value: "APPROVE",
    },
  ];

  const [alertInfo, setAlertInfo] = useState<any>({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });

  const [shouldUpdateRole, setShouldUpdateRole] = useState(false);

  const onSubmit = async (_data: any) => {
    setIsSubmitting(true);
    const allCategories = [
      "Masters",
      "ProcureToPay",
      "Dashboard",
      "Inventory",
      "Reports",
      "ProjectManagementSystem",
    ];
    const hasAnyCategory = allCategories.some((category) =>
      _data.hasOwnProperty(category)
    );
    let uncheckedCategories = [];
    if (hasAnyCategory) {
      const uncheckedDefaults = data?.accessibility.filter(
        (item: any) => _data[item?.category] !== true
      );
      uncheckedCategories = uncheckedDefaults?.map(
        (item: any) => item?.category
      );
    } else {
      uncheckedCategories = []; // no category checkbox interaction
    }

    // return;

    const prefix = `${modalEditBlockName}_`;

    // Step 1: Build permissionsMap
    const permissionsMap: Record<string, Record<string, number>> = {};

    Object.entries(_data).forEach(([key, value]) => {
      if (!key.startsWith(prefix)) return;

      const [, moduleID, action] = key.split("_");
      if (!permissionsMap[moduleID]) {
        permissionsMap[moduleID] = {};
      }

      permissionsMap[moduleID][action] = value ? 1 : 0;
    });

    console.log("permissionsMap", permissionsMap);

    // Step 2: Set updated data
    setData((prev: any) => ({
      ...prev,
      accessibility: prev.accessibility.map((entry: any) => {
        if (entry?.category !== modalEditBlockName) return entry;
        console.log("entry", entry);

        if (modalEditBlockName === "Reports") {
          // For Reports, modules are nested
          const updatedModules = entry.modules.map((subCat: any) => ({
            ...subCat,
            modules: subCat.modules.map((mod: any) => {
              const actions = permissionsMap[mod.moduleID];
              if (!actions) return mod;
              return {
                ...mod,
                actions: {
                  add: actions.add,
                  view: actions.view,
                  edit: actions.edit,
                  cancel: actions.cancel,
                  approve: actions.approve,
                  reject: actions.reject,
                },
                allowedToEdit: mod.allowedToEdit,
              };
            }),
          }));
          return { ...entry, modules: updatedModules };
        } else if (
          modalEditBlockName === "Masters" ||
          modalEditBlockName === "Dashboard"
        ) {
          const updatedModules = entry.modules.map((mod: any) => {
            const actions = permissionsMap[mod.moduleID];
            if (!actions) return mod;

            const isAddChecked = actions.add === 1;

            return {
              ...mod,
              actions: {
                add: isAddChecked ? 1 : 0,
                view: isAddChecked ? 1 : 0,
                edit: isAddChecked ? 1 : 0,
                cancel: isAddChecked ? 1 : 0,
                approve: isAddChecked ? 1 : 0,
                reject: isAddChecked ? 1 : 0,
              },
              allowedToEdit: mod.allowedToEdit,
            };
          });
          console.log("updatedModules", updatedModules);
          return {
            ...entry,
            modules: updatedModules,
          };
        } else {
          const updatedModules = entry?.modules.map((mod: any) => {
            const modIdStr = mod.moduleID; // ensure string match
            const actions = permissionsMap[modIdStr];
            console.log("actions", actions);
            if (!actions) return mod; // untouched module
            return {
              ...mod,
              actions: {
                add: actions.add,
                view: actions.view,
                edit: actions.edit,
                cancel: actions.cancel,
                approve: actions.approve,
                reject: actions.reject,
              },
              allowedToEdit: mod.allowedToEdit,
            };
          });
          return {
            ...entry,
            modules: updatedModules,
          };
        }
      }),
    }));
    if (modalEditBlockName === "GeneralInformation") {
      // Step 1: Get all selected checkboxes
      const selectedCategories = Object.entries(_data)
        .filter(
          ([key, value]) =>
            [
              "Masters",
              "Reports",
              "Dashboard",
              "Inventory",
              "ProcureToPay",
              "ProjectManagementSystem",
            ].includes(key) && value === true
        )
        .map(([key]) => key);

      // Step 2: Validate at least one selected
      if (selectedCategories.length === 0) {
        setAlertInfo({
          type: "error",
          message: "Please select at least one module accessibility",
          errors: [],
        });
        return;
      }

      // Step 3: Get current accessibility categories
      const existingCategories = data?.accessibility.map(
        (item: any) => item?.category
      );

      // Step 4: Remove unselected accessibility from `data.accessibility`
      const updatedAccessibility = data?.accessibility.filter((item: any) =>
        selectedCategories.includes(item?.category)
      );

      // Step 5: Fetch and add any newly selected categories
      const newlySelectedCategories = selectedCategories.filter(
        (cat) => !existingCategories.includes(cat)
      );

      let newConfigs: any = [];
      if (newlySelectedCategories.length > 0) {
        newConfigs = await Promise.all(
          newlySelectedCategories.map((cat) => fetchModuleConfig(cat))
        );
      }

      setData((prev: any) => ({
        ...prev,
        accessibility: [...updatedAccessibility, ...newConfigs],
      }));
    }
    data.categories = uncheckedCategories || [];
    // return;
    setShouldUpdateRole(true);
  };

  const fetchModuleConfig = async (category?: string) => {
    try {
      const res = await rolesApi.getModuleConfig(); // returns all categories
      const allConfigs = res.data;

      if (category) {
        // Filter for specific category if provided
        const match = allConfigs.find(
          (item: any) => item?.category === category
        );
        return match ? match : null;
      }

      // Return all if no category filter
      return allConfigs;
    } catch (err) {
      console.error("Failed to fetch module config:", err);
      throw err;
    }
  };

  useEffect(() => {
    if (shouldUpdateRole) {
      updateRole();
      setShouldUpdateRole(false); // reset flag
    }
  }, [shouldUpdateRole]);

  const updateRole = async () => {
    console.log("API::DATA", data);
    const formattedModules = data?.accessibility?.flatMap((entry: any) => {
      // Case 1: "Reports" - nested categories inside modules
      if (entry?.category === "Reports") {
        return entry?.modules.flatMap((subCat: any) =>
          subCat.modules.map((mod: any) => ({
            module: String(mod.moduleID),
            add: !!mod.actions?.add,
            view: !!mod.actions?.view,
            edit: !!mod.actions?.edit,
            cancel: !!mod.actions?.cancel,
            approve: !!mod.actions?.approve,
            reject: !!mod.actions?.reject,
          }))
        );
      }

      // Case 2: Normal categories
      return entry?.modules.map((mod: any) => ({
        module: String(mod.moduleID),
        add: !!mod.actions?.add,
        view: !!mod.actions?.view,
        edit: !!mod.actions?.edit,
        cancel: !!mod.actions?.cancel,
        approve: !!mod.actions?.approve,
        reject: !!mod.actions?.reject,
      }));
    });

    console.log("formattedModules", formattedModules);
    let submitData = {
      roleName: data.roleName,
      description: data.description,
      referenceID: data.referenceID,
      deptID: data.deptID,
      accessibility: formattedModules,
      categories: data.categories,
    };
    try {
      const { status, message } = await rolesApi.updateRoleById(
        roleID,
        submitData
      );
      if (status) {
        Swal.fire("Updated!", "Role has been updated", "success");
        fetchRoleById(roleID);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {}finally{
      setIsSubmitting(false);
    }
  };
  // const fetchModuleConfig = async () => {
  //   try {
  //     const res = await rolesApi.getModuleConfig();
  //     const data = res.data;
  //     setaccessibilityKeys(
  //       data.map((obj: any) => ({
  //         label: obj.moduleName,
  //         value: obj.moduleID.toString(),
  //         isReport: obj.isReport,
  //         reportType: obj.reportType,
  //         isSupplier: obj.isSupplier,
  //         isMaster: obj.isMaster,
  //       }))
  //     );
  //   } catch (err) {
  //     throw err;
  //   }
  // };
  const fetchDept = async () => {
    try {
      const { data, status, message } = await departments.fetchDeptData();
      if (status) {
        setDepartmentData(
          data.map((obj: any) => ({
            label: obj.deptName,
            value: obj.deptID.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };
  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    fetchDept();
    fetchModuleConfig();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document
      .getElementsByClassName("nk-header")[0]
      .addEventListener("click", function () {
        updateSm(false);
      });
    const id = roleID;
    console.log("id", id);
    if (id !== undefined || null || "") {
      fetchRoleById(id);
    }
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, [roleID]);

  const openEditModal = (modalEditBlockName: any) => {
    setModalEditBlockName(modalEditBlockName);
    setGIModal(true);
  };

  const fetchRoleById = async (id: any) => {
    try {
      const { data, status, message } = await rolesApi.fetchRoleById(id);
      if (status) {
        const newData = data;
        setData(newData); // Update data with fetched response
        setFormData({
          roleName: newData.roleName,
          description: newData.description,
          referenceID: newData.referenceID,
          status: newData.status,
          deptID: newData?.deptID?.toString(),
          accessibility: [],
        });
        // data?.accessibility?.forEach((moduleObj: any) => {
        //   let moduleName = moduleObj?.module?.toString();
        //   setValue(`${moduleName}_add`, moduleObj.add);
        //   setValue(`${moduleName}_view`, moduleObj.view);
        //   setValue(`${moduleName}_edit`, moduleObj.edit);
        //   setValue(`${moduleName}_cancel`, moduleObj.cancel);
        //   setValue(`${moduleName}_approve`, moduleObj.approve);
        //   setValue(`${moduleName}_reject`, moduleObj.reject);
        // });
        setValue("roleName", data.roleName);
        setValue("description", data.description);
        setValue("deptID", data?.deptID?.toString());
        setValue("referenceID", data.referenceID);
        setGIModal(false);
      }
    } catch (err: any) {
      Swal.fire(
        "Failed!",
        err.response?.data?.message || "Unknown error",
        "error"
      );
    }
  };

  return (
    <React.Fragment>
      <Head title="View Role"></Head>
      <Content>
        {data && (
          <>
            <BlockHead size="sm">
              <BlockBetween className="g-3">
                <BlockHeadContent>
                  <BlockTitle page>
                    Role Details -{" "}
                    <strong className="text-primary small">
                      {data.roleName}
                    </strong>
                  </BlockTitle>
                  <BlockDes className="text-soft">
                    <ul className="list-inline">
                      <li>
                        Created At:{" "}
                        <span className="text-base">
                          {FormatDate(data.createdDate)}
                        </span>
                      </li>
                    </ul>
                  </BlockDes>
                </BlockHeadContent>
                <BlockHeadContent>
                  {/* {allowedActions?.edit ? (
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                      style={{ marginRight: "10px" }}
                      onClick={() => openEditModal()}
                    >
                      <Icon name="edit-alt-fill"></Icon>
                      <span>Edit</span>
                    </Button>
                  ) : (
                    <></>
                  )} */}
                  <Link to={`${process.env.PUBLIC_URL}/roles`}>
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                    >
                      <Icon name="arrow-left"></Icon>
                      <span>Back</span>
                    </Button>
                    <Button
                      outline
                      className="btn-icon bg-white d-inline-flex d-sm-none"
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                  </Link>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>

            <Block>
              <Row className="gy-5">
                <Col
                  lg="5"
                  sm={undefined}
                  md={undefined}
                  xxl={undefined}
                  size={undefined}
                  className={undefined}
                >
                  <BlockHead>
                    <BlockBetween>
                      <BlockHeadContent>
                        <BlockTitle tag="h5">General Information</BlockTitle>
                        <p>Name, Address etc.</p>
                      </BlockHeadContent>
                      <BlockHeadContent>
                        {allowedActions?.edit ? (
                          <Button
                            outline
                            className="d-none d-sm-inline-flex"
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                              setValue(
                                "Masters",
                                data?.accessibility.some(
                                  (item: any) => item?.category === "Masters"
                                )
                              );
                              setValue(
                                "ProcureToPay",
                                data?.accessibility.some(
                                  (item: any) =>
                                    item?.category === "ProcureToPay"
                                )
                              );
                              setValue(
                                "Inventory",
                                data?.accessibility.some(
                                  (item: any) => item?.category === "Inventory"
                                )
                              );
                              setValue(
                                "Reports",
                                data?.accessibility.some(
                                  (item: any) => item?.category === "Reports"
                                )
                              );
                              setValue(
                                "Dashboard",
                                data?.accessibility.some(
                                  (item: any) => item?.category === "Dashboard"
                                )
                              );
                              setValue(
                                "ProjectManagementSystem",
                                data?.accessibility.some(
                                  (item: any) =>
                                    item?.category === "ProjectManagementSystem"
                                )
                              );

                              openEditModal("GeneralInformation");
                            }}
                          >
                            <Icon name="edit-alt-fill"></Icon>
                          </Button>
                        ) : (
                          <></>
                        )}
                      </BlockHeadContent>
                    </BlockBetween>
                  </BlockHead>
                  <Card className="card-bordered">
                    <ul className="data-list is-compact">
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Role Name</div>
                          <div className="data-value">{data.roleName}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Description</div>
                          <div className="data-value">{data.description}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Role ID</div>
                          <div className="data-value">{data.referenceID}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Department Name</div>
                          <div className="data-value">
                            {
                              departmentData?.find(
                                (d: any) => d.value == data.deptID
                              )?.label
                            }
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Status</div>
                          <div className="data-value">{data.status}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Accessibility</div>
                          <div className="data-value">
                            {data?.accessibility
                              ?.map((item: any) => item?.category)
                              .join(", ")}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Card>
                </Col>

                {data?.accessibility?.map((item: any) => {
                  if (item?.category !== "Reports") {
                    return (
                      <Col
                        lg="7"
                        sm={undefined}
                        md={undefined}
                        xxl={undefined}
                        size={undefined}
                        className={undefined}
                      >
                        <BlockHead>
                          <BlockBetween>
                            <BlockHeadContent>
                              <BlockTitle tag="h5">{item?.category} </BlockTitle>
                              <p>{item?.category} Accessibility Details etc.</p>
                            </BlockHeadContent>
                            <BlockHeadContent>
                              {allowedActions?.edit ? (
                                <Button
                                  outline
                                  className="d-none d-sm-inline-flex"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => openEditModal(item?.category)}
                                >
                                  <Icon name="edit-alt-fill"></Icon>
                                </Button>
                              ) : (
                                <></>
                              )}
                            </BlockHeadContent>
                          </BlockBetween>
                        </BlockHead>

                        <Card className="card-bordered">
                          <table
                            className="table table-hover"
                            id="accessesbility"
                          >
                            <thead>
                              <tr>
                                {updatedAccessibilityOptions.map(
                                  (_item: any) => {
                                    return (
                                      <th key={_item.value}>{_item.label}</th>
                                    );
                                  }
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {item?.modules?.map((item_: any) => {
                                return (
                                  <tr>
                                    <td>{item_?.moduleName}</td>
                                    <td>
                                      {item_?.actions?.add == 1 ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.view ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.edit ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.cancel ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.approve ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    {/* <td>
                                {item_?.actions?.reject ? (
                                  <Icon
                                    name="check-circle-fill"
                                    className="text-success"
                                  />
                                ) : (
                                  <Icon
                                    name="cross-circle-fill"
                                    className="text-danger"
                                  />
                                )}
                              </td> */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </Card>
                      </Col>
                    );
                  } else if (item?.category === "Reports") {
                    return (
                      <Col
                        lg="7"
                        sm={undefined}
                        md={undefined}
                        xxl={undefined}
                        size={undefined}
                        className={undefined}
                      >
                        <BlockHead>
                          <BlockBetween>
                            <BlockHeadContent>
                              <BlockTitle tag="h5">{item?.category} </BlockTitle>
                              <p>
                                {item?.category} Accessibility Detailsss etc.
                              </p>
                            </BlockHeadContent>
                            <BlockHeadContent>
                              {allowedActions?.edit ? (
                                <Button
                                  outline
                                  className="d-none d-sm-inline-flex"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => openEditModal(item?.category)}
                                >
                                  <Icon name="edit-alt-fill"></Icon>
                                </Button>
                              ) : (
                                <></>
                              )}
                            </BlockHeadContent>
                          </BlockBetween>
                        </BlockHead>

                        <Card className="card-bordered">
                          {item?.modules?.map((item__: any) => (
                            <>
                              <div
                                key={item__.category}
                                style={{ margin: "2%" }}
                              >
                                <h5>{item__.category}</h5>
                              </div>
                              <table
                                className="table table-hover"
                                id="accessesbility"
                              >
                                <thead>
                                  <tr>
                                    <th className="w-70">Sub-Feature</th>
                                    <th>View</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item__.modules?.map((item_: any) => {
                                    return (
                                      <tr>
                                        <td className="w-70">
                                          {item_?.moduleName}
                                        </td>

                                        <td>
                                          {item_?.actions?.view ? (
                                            <Icon
                                              name="check-circle-fill"
                                              className="text-success"
                                            />
                                          ) : (
                                            <Icon
                                              name="cross-circle-fill"
                                              className="text-danger"
                                            />
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </>
                          ))}
                        </Card>
                      </Col>
                    );
                  }
                })}
              </Row>
            </Block>

            <Modal
              isOpen={modalGI}
              className="modal-dialog-centered"
              size="xl"
              toggle={() => setGIModal(false)}
              backdrop="static"
            >
              <a
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  setGIModal(false);
                }}
                className="close"
              >
                <Icon name="cross-sm"></Icon>
              </a>
              {modalEditBlockName === "GeneralInformation" && (
                <>
                  <ModalBody>
                    <div className="">
                      <div className="nk-modal-head">
                        <h5 className="title">Edit General Information </h5>
                      </div>
                      <div className="nk-tnx-details mt-sm-3">
                        {alertInfo.message && (
                          <div className="mb-3 mt-1">
                            <Alert
                              color={
                                alertInfo.type === "error"
                                  ? "danger"
                                  : "success"
                              }
                              className="alert-icon"
                            >
                              <strong>{alertInfo.message}</strong>
                              <Icon
                                name={
                                  alertInfo.type === "error"
                                    ? "alert-circle"
                                    : "check-circle"
                                }
                              />
                              {alertInfo.errors.length > 0 ? (
                                <ul>
                                  {alertInfo.errors.map(
                                    (err: any, index: any) => (
                                      <li key={index}>{err}</li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                ""
                              )}
                            </Alert>
                          </div>
                        )}
                        <FormProvider {...methods}>
                          <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <Row className="gy-4">
                              <Col md="4">
                                <FormInput
                                  name="referenceID"
                                  label="Internal ID"
                                  required={true}
                                  type="text"
                                  pattern={/^[a-zA-Z0-9./_-]+$/}
                                  maxLength={10}
                                  placeholder="Enter Internal ID"
                                />
                              </Col>
                              <Col md="4">
                                <FormSelect
                                  name="deptID"
                                  required={true}
                                  label="Department Name"
                                  options={departmentData}
                                  placeholder="Select Department Name"
                                />
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="roleName"
                                  label="Role Name"
                                  required={true}
                                  type="text"
                                  minLength={2}
                                  // maxLength={30}
                                  placeholder="Enter Role Name"
                                />
                              </Col>
                              <Col md="12">
                                <FormTextArea
                                  name="description"
                                  label="Description"
                                  required={true}
                                  maxLength={50}
                                  placeholder="Enter Role Description"
                                />
                              </Col>
                              <Col md="12">
                                <div className="form-group">
                                  <label className="form-label">
                                    Accessibility
                                  </label>
                                </div>
                                <div className="data-col align-center ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"Masters"}
                                      optionLabel={"Masters"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"Reports"}
                                      optionLabel={"Reports"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"ProcureToPay"}
                                      optionLabel={"Procure To Pay"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div>
                                {/* <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"Inventory"}
                                      optionLabel={"Inventory"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div> */}
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"Dashboard"}
                                      optionLabel={"Dashboard"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div>
                                {/* <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-45">
                                    <FormCheckbox
                                      name={"ProjectManagementSystem"}
                                      optionLabel={"Project Management System"}
                                      required
                                      onChange={() => {}}
                                    />
                                  </div>
                                </div> */}
                              </Col>
                            </Row>
                             <Alert
                            isOpen={true}
                            color="danger"
                            className="start-0 w-100 py-2 mt-4"
                            style={{
                              top: 0,
                              textAlign: "left",
                              fontSize: "14px",
                              cursor: "default",
                            }}
                          >
                            <ReactTyped
                              strings={[
                                `Note: Updating this role will apply the changes to all users assigned to it. This action cannot be undone.`,
                              ]}
                              typeSpeed={5}
                              showCursor={false}
                            />
                          </Alert>
                            <Row className="gy-4 mt-2">
                              <Col md="12">
                                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                  <li>
                                    {isSubmitting ? (
                                    <Button color="primary" type="button">
                                      <Spinner size="sm" color="light" />
                                    </Button>
                                  ) : (
                                    <Button
                                      color="primary"
                                      size="lg"
                                      type="submit"
                                    >
                                      Update
                                    </Button>
                                    )}
                                  </li>
                                  <li>
                                    <a
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setGIModal(false);
                                      }}
                                      className="link link-light"
                                    >
                                      Cancel
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </ModalBody>
                </>
              )}
              {modalEditBlockName !== "GeneralInformation" && (
                <ModalBody>
                  <div className="">
                    <div className="nk-modal-head">
                      <h5 className="title">Edit Accessibility </h5>
                    </div>
                    <div className="nk-tnx-details mt-sm-3">
                      <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                          <Row className="gy-4">
                            <Col size="12">
                              {modalEditBlockName === "Reports" ? (
                                <>
                                  {/* Render one table per report sub-category */}
                                  {data.accessibility
                                    ?.find(
                                      (obj: any) =>
                                        obj.category === modalEditBlockName
                                    )
                                    ?.modules.map((reportCategory: any) => (
                                      <div
                                        key={reportCategory.category}
                                        style={{ marginBottom: 40 }}
                                      >
                                        <h5>{reportCategory.category}</h5>
                                        <table
                                          className="table table-hover"
                                          id="accessesbility"
                                        >
                                          <thead>
                                            <tr>
                                              <th>Sub-Feature</th>
                                              <th>View</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {reportCategory.modules.map(
                                              (item: any) => {
                                                const actionTypes = [
                                                  // "add",
                                                  "view",
                                                  // "edit",
                                                  // "cancel",
                                                  // "approve",
                                                ];
                                                // Set default checkbox values on load
                                                actionTypes.forEach(
                                                  (action) => {
                                                    const name = `${modalEditBlockName}_${item.moduleID}_${action}`;
                                                    const isChecked =
                                                      item.actions?.[action] ===
                                                      true;
                                                    setValue(name, isChecked);
                                                  }
                                                );

                                                return (
                                                  <tr key={item.moduleID}>
                                                    <td>{item.moduleName}</td>
                                                    {actionTypes.map(
                                                      (action) => {
                                                        const name = `${modalEditBlockName}_${item.moduleID}_${action}`;
                                                        const isDisabled =
                                                          action !== "view" &&
                                                          !item.allowedToEdit?.includes(
                                                            action
                                                          );
                                                        return (
                                                          <td key={name}>
                                                            <FormCheckbox
                                                              name={name}
                                                              optionLabel=""
                                                              noGap={true}
                                                              size="small"
                                                              disabled={
                                                                isDisabled
                                                              }
                                                            />
                                                          </td>
                                                        );
                                                      }
                                                    )}
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    ))}
                                </>
                              ) : modalEditBlockName === "Masters" ||
                                modalEditBlockName === "Dashboard" ? (
                                <table
                                  className="table table-hover"
                                  id="accessesbility"
                                >
                                  <thead>
                                    <tr>
                                      <th>Sub-Feature</th>
                                      <th>Accessibility</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      const foundCategory =
                                        data.accessibility?.find(
                                          (obj: any) =>
                                            obj.category === modalEditBlockName
                                        );
                                      console.log(
                                        "modalEditBlockName",
                                        modalEditBlockName
                                      );
                                      if (!foundCategory) return null;
                                      console.log(
                                        "foundCategory",
                                        foundCategory
                                      );
                                      return foundCategory.modules.map(
                                        (mod: any, i: number) => {
                                          const actionTypes = ["add"];
                                          actionTypes.forEach((action) => {
                                            const name = `${modalEditBlockName}_${mod.moduleID}_${action}`;
                                            console.log("name", name);
                                            const isChecked =
                                              modalEditBlockName === "Masters"
                                                ? Number(
                                                    mod.actions?.[action]
                                                  ) === 1
                                                : Number(
                                                    mod.actions?.["view"]
                                                  ) === 1;
                                            console.log("isChecked", isChecked);
                                            setValue(name, isChecked);
                                          });

                                          return (
                                            <tr key={mod.moduleID}>
                                              <td>{mod.moduleName}</td>
                                              {actionTypes.map((action) => {
                                                const name = `${modalEditBlockName}_${mod.moduleID}_${action}`;
                                                const isDisabled =
                                                  action !== "view" &&
                                                  !mod.allowedToEdit?.includes(
                                                    action
                                                  );
                                                return (
                                                  <td key={name}>
                                                    <FormCheckbox
                                                      name={name}
                                                      optionLabel=""
                                                      noGap={true}
                                                      size="small"
                                                      disabled={isDisabled}
                                                    />
                                                  </td>
                                                );
                                              })}
                                            </tr>
                                          );
                                          //   }
                                          // );
                                        }
                                      );
                                    })()}
                                  </tbody>
                                </table>
                              ) : (
                                <table
                                  className="table table-hover"
                                  id="accessesbility"
                                >
                                  <thead>
                                    <tr>
                                      {updatedAccessibilityOptions.map(
                                        (_item: any) => {
                                          return (
                                            <th key={_item.value}>
                                              {_item.label}
                                            </th>
                                          );
                                        }
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      if (!modalEditBlockName) return null;
                                      const foundCategory =
                                        data.accessibility?.find(
                                          (obj: any) =>
                                            obj.category === modalEditBlockName
                                        );
                                      if (!foundCategory) return null;
                                      return (
                                        <>
                                          {foundCategory?.modules?.map(
                                            (item: any, index: number) => {
                                              if (!item || !item.moduleID)
                                                return null;
                                              setValue(
                                                `${modalEditBlockName}_${item.moduleID}_add`,
                                                Number(item?.actions?.add) === 1
                                              );
                                              setValue(
                                                `${modalEditBlockName}_${item.moduleID}_view`,
                                                Number(item?.actions?.view) ===
                                                  1
                                              );
                                              setValue(
                                                `${modalEditBlockName}_${item.moduleID}_edit`,
                                                Number(item?.actions?.edit) ===
                                                  1
                                              );
                                              setValue(
                                                `${modalEditBlockName}_${item.moduleID}_cancel`,
                                                Number(
                                                  item?.actions?.cancel
                                                ) === 1
                                              );
                                              setValue(
                                                `${modalEditBlockName}_${item.moduleID}_approve`,
                                                Number(
                                                  item?.actions?.approve
                                                ) === 1
                                              );
                                              return (
                                                <tr key={`item-${index}`}>
                                                  <td>{item.moduleName}</td>
                                                  <td>
                                                    <FormCheckbox
                                                      name={`${modalEditBlockName}_${item.moduleID}_add`}
                                                      disabled={
                                                        !item?.allowedToEdit?.includes(
                                                          "add"
                                                        )
                                                      }
                                                      optionLabel=""
                                                      noGap={true}
                                                      size={"small"}
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormCheckbox
                                                      name={`${modalEditBlockName}_${item.moduleID}_view`}
                                                      optionLabel=""
                                                      noGap={true}
                                                      size={"small"}
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormCheckbox
                                                      disabled={
                                                        !item?.allowedToEdit?.includes(
                                                          "edit"
                                                        )
                                                      }
                                                      name={`${modalEditBlockName}_${item.moduleID}_edit`}
                                                      optionLabel=""
                                                      noGap={true}
                                                      size={"small"}
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormCheckbox
                                                      disabled={
                                                        !item?.allowedToEdit?.includes(
                                                          "cancel"
                                                        )
                                                      }
                                                      name={`${modalEditBlockName}_${item.moduleID}_cancel`}
                                                      optionLabel=""
                                                      noGap={true}
                                                      size={"small"}
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormCheckbox
                                                      disabled={
                                                        !item?.allowedToEdit?.includes(
                                                          "approve"
                                                        )
                                                      }
                                                      name={`${modalEditBlockName}_${item.moduleID}_approve`}
                                                      optionLabel=""
                                                      noGap={true}
                                                      size={"small"}
                                                    />
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}

                                          {/* Render reports grouped by reportType */}
                                          {/* {Object.keys(reportGroups).map(
                                          (reportType, index) => (
                                            <React.Fragment
                                              key={`report-type-${index}`}
                                            >
                                              <tr>
                                                <td colSpan={6}>
                                                  <h4
                                                    style={{
                                                      marginTop: "20px",
                                                      marginBottom: "20px",
                                                      color: "black",
                                                    }}
                                                  >
                                                    {reportType ||
                                                      "Other Reports"}
                                                  </h4>
                                                </td>
                                              </tr>

                                              {reportGroups[reportType].map(
                                                (item: any, idx: number) => (
                                                  <tr
                                                    key={`report-item-${idx}`}
                                                  >
                                                    <td>{item.label}</td>
                                                    <td>
                                                      <FormCheckbox
                                                        disabled={[
                                                          ...readOnlyAddModules,
                                                          ...readOnlyLabels,
                                                        ].includes(item.label)}
                                                        name={`${item.value}_add`}
                                                        optionLabel=""
                                                        noGap={true}
                                                        size={"small"}
                                                      />
                                                    </td>
                                                    <td>
                                                      <FormCheckbox
                                                        name={`${item.value}_view`}
                                                        optionLabel=""
                                                        noGap={true}
                                                        size={"small"}
                                                      />
                                                    </td>
                                                    <td>
                                                      <FormCheckbox
                                                        disabled={[
                                                          ...readOnlyUpdateModules,
                                                          ...readOnlyLabels,
                                                        ].includes(item.label)}
                                                        name={`${item.value}_edit`}
                                                        optionLabel=""
                                                        noGap={true}
                                                        size={"small"}
                                                      />
                                                    </td>
                                                    <td>
                                                      <FormCheckbox
                                                        disabled={[
                                                          ...readOnlyDeleteModules,
                                                          ...readOnlyLabels,
                                                        ].includes(item.label)}
                                                        name={`${item.value}_cancel`}
                                                        optionLabel=""
                                                        noGap={true}
                                                        size={"small"}
                                                      />
                                                    </td>
                                                    <td>
                                                      <FormCheckbox
                                                        disabled={[
                                                          ...readOnlyRejectModules,
                                                          ...readOnlyLabels,
                                                        ].includes(item.label)}
                                                        name={`${item.value}_approve`}
                                                        optionLabel=""
                                                        noGap={true}
                                                        size={"small"}
                                                      />
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </React.Fragment>
                                          )
                                        )} */}
                                        </>
                                      );
                                    })()}
                                  </tbody>
                                </table>
                              )}
                            </Col>
                          </Row>
                          <Row className={undefined}>
                            <Col size="12">
                              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                <li>
                                  <Button
                                    color="primary"
                                    size="lg"
                                    type="submit"
                                    // onClick={() => submitForm()}
                                  >
                                    Update
                                  </Button>
                                </li>
                                <li>
                                  <a
                                    href="#dropdownitem"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      setGIModal(false);
                                    }}
                                    className="link link-light"
                                  >
                                    Cancel
                                  </a>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </form>
                      </FormProvider>
                    </div>
                  </div>
                </ModalBody>
              )}
            </Modal>
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default RoleViewDetails;
